module.exports = __webpack_public_path__ + "static/img/landingPageGraphic.4766b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPageGraphic.png
// module id = XZ91
// module chunks = 1